// Central translation dictionary for public-facing landing page
// Keys are flat to keep lookup simple

const translations = {
  en: {
    // Navbar
    'nav.for_managers': 'For Managers',
    'nav.login': 'Login',
    'nav.signup': 'Sign Up',
    'nav.tagline': 'For owners by an owner',
    'nav.lang_toggle': 'हिं',
    'nav.lang_label': 'Language',

    // Beta banner
    'beta.pill': 'BETA',
    'beta.message': "We're in beta — shipping features at rocket speed. Got feedback? DM us.",
    'beta.message_short': "In beta · shipping at rocket speed",

    // Hero
    'hero.brand': 'RentKollect',
    'hero.badge': '🏠 FOR OWNERS, BY AN OWNER',
    'hero.h1_line1': 'Stop chasing rent.',
    'hero.h1_line2': 'Stop living in',
    'hero.h1_trail': '.',
    'hero.rotating_words': ['Excel', 'registers', 'old apps'],
    'hero.subtext':
      "RentKollect runs your PG, hostel, or co-living the way it should have been done since day one — built in India, by an owner who felt every pain point you're feeling right now.",
    'hero.tagline': 'Save time. Work less. Earn more.',
    'hero.i_manage': 'I manage a',
    'hero.mobile_placeholder': 'Enter mobile',
    'hero.submit_idle': 'Request for a demo',
    'hero.submit_loading': 'Submitting...',
    'hero.toast_title': 'Demo request submitted!',
    'hero.toast_desc': (num) => `We'll contact you shortly at ${num}`,

    // Hero preview card
    'card.url': 'rentkollect.com/manager',
    'card.kicker': 'Your super-app',
    'card.kicker_h': 'Property Renting, solved.',
    'card.live': 'LIVE',
    'card.stat.collected': 'Collected',
    'card.stat.due': 'Due',
    'card.stat.occupancy': 'Occupancy',
    'card.f1.title': 'Automatic Rent & Dues Tracking',
    'card.f1.sub': "See who paid, who's pending, who needs a nudge",
    'card.f2.title': 'Bulk Room & Floor Management',
    'card.f2.sub': "40 rooms added in 60 seconds — tap, don't type",
    'card.f3.title': 'AI Command Center',
    'card.f3.sub': '"Show me dues over ₹10k in HSR Layout"',
    'card.bharat_kicker': 'MADE IN BHARAT',
    'card.bharat_title_prefix': 'Bharat ka pehla AI-powered',
    'card.bharat_title_suffix': 'app',
    'card.property_words': ['PG', 'co-living', 'hostel'],
    'card.secure': '100% secure',

    // Property types
    'prop.coliving': 'Co-Living',
    'prop.hostel': 'Hostel/PG',
    'prop.flat': 'Flat',
    'prop.studio': 'Studio',

    // Features section
    'feat.live_badge': 'LIVE',
    'feat.ai_badge': 'AI · LIVE',
    'feat.soon_badge': 'COMING SOON',
    'feat.new_badge': 'NEW',
    'feat.stats_chip': (live, soon) => `${live} features live · ${soon} shipping soon`,
    'feat.recently_shipped_title': 'Shipped this month',
    'feat.recently_shipped_subtitle': "We push to production every week. Here's what just dropped:",
    'feat.recent.1_title': 'Live P&L Dashboard',
    'feat.recent.1_desc': '6-month trend, period-over-period delta, expense breakdown by category.',
    'feat.recent.2_title': 'Real-time Data Sync',
    'feat.recent.2_desc': 'Record rent on your phone → laptop dashboard updates in 250ms. Across tabs too.',
    'feat.recent.3_title': 'Banks & UPI Routing',
    'feat.recent.3_desc': 'Different bank/VPA per property. No more reconciling 5 properties into 1 account.',
    'feat.recent.4_title': 'Smart Tenant Lifecycle',
    'feat.recent.4_desc': 'Booking token auto-adjusts to rent or deposit. Cancel notice if tenant stays.',
    'feat.h2_a': 'Everything you need to run your',
    'feat.h2_b': 'PG, hostel,',
    'feat.h2_c': 'or',
    'feat.h2_d': 'co-living',
    'feat.h2_trail': '.',
    'feat.intro':
      "Built ground-up for Indian property owners — no jugaad, no Excel chaos, no chasing tenants at 11pm. Every feature below comes from actual conversations with owners running 20-bed PGs in Rajender Nagar and 200-bed co-livings in HSR Layout.",
    'feat.footer_note_a': 'We ship fast. Features marked',
    'feat.footer_note_b': 'are actively in development — drop your number in the form above and we\'ll ping you when they go live.',

    // Feature categories
    'feat.money.title': 'Money & Rent Collection',
    'feat.money.tag': '"Bhai paisa kab aayega?" — solved.',
    'feat.money.f1': 'Automatic Rent & Dues Tracking',
    'feat.money.f2': 'Dues Dashboard with Ageing Report',
    'feat.money.f3': 'Expense Tracking with Photo OCR',
    'feat.money.f4': '6-Month Revenue Trends per Property',
    'feat.money.f5': 'Auto-Generated Invoices & Receipts (PDF)',
    'feat.money.f6': 'WhatsApp Payment Reminders & Receipts',
    'feat.money.f7': 'Prepaid Credit Wallet (pay once, use anywhere)',
    'feat.money.f8': 'Live Profit & Loss Dashboard with 6-month trend',
    'feat.money.f9': 'Banks & UPI Routing — collect per property to different accounts',
    'feat.money.f10': 'Real-time Sync — numbers update live across every tab & device',

    'feat.prop.title': 'Property & Rooms',
    'feat.prop.tag': 'Your Gurgaon PG and HSR Layout co-living, on one dashboard.',
    'feat.prop.f1': 'Multi-Property Management',
    'feat.prop.f2': "Bulk Room Add (tap, don't type)",
    'feat.prop.f3': 'Room Photos & Floor Layout',
    'feat.prop.f4': 'Public Listing Website for Each Property',
    'feat.prop.f5': 'Electricity Meter Tracking',

    'feat.ten.title': 'Tenants & Leads',
    'feat.ten.tag': 'From chai-pani enquiry to signed agreement — one flow.',
    'feat.ten.f1': 'Tenant Profiles, KYC & Documents',
    'feat.ten.f2': 'Lead Management with AI Lead Scoring',
    'feat.ten.f3': 'Bookings & Move-in Flow',
    'feat.ten.f4': 'Digital Rent Agreements',
    'feat.ten.f5': 'Police Verification Register',
    'feat.ten.f6': 'Aadhaar Verification',
    'feat.ten.f7': 'Booking → Move-In → Tenant lifecycle with token auto-adjust',
    'feat.ten.f8': 'Notice period workflow (put on notice, cancel, mark exited)',

    'feat.ops.title': 'Day-to-Day Operations',
    'feat.ops.tag': 'Mess, maintenance, safai — no more WhatsApp groups gone rogue.',
    'feat.ops.f1': 'Complaints & Ticketing',
    'feat.ops.f2': 'Tasks & Staff Assignments',
    'feat.ops.f3': 'Food / Mess Menu Planning',
    'feat.ops.f4': 'Daily Cleaning Checklist',
    'feat.ops.f5': 'Assets Register (geyser, AC, beds)',
    'feat.ops.f6': 'Team Management with Role-based Access',
    'feat.ops.f7': 'Notice Board (broadcast to tenants & staff)',
    'feat.ops.f8': 'Visitor Log (front-desk register)',

    'feat.intel.title': 'Intelligence & Automation',
    'feat.intel.tag': 'Let the app do the thinking while you do the living.',
    'feat.intel.f1': 'AI Command Center (ask anything about your PG)',
    'feat.intel.f2': 'Custom Reports (dues, collections, P&L)',
    'feat.intel.f3': 'Smart Reminders & Scheduler',
    'feat.intel.f4': 'WhatsApp Business Automation',
    'feat.intel.f5': 'Native Android & iOS App',

    // Comparison
    'cmp.h2': 'Why rent like 1990s when you are in 2026?',
    'cmp.sub': 'Save time, Work less, Earn more',
    'cmp.trad_title': 'Traditional Property',
    'cmp.trad_sub': 'Manual & Time-consuming',
    'cmp.smart_title': 'RentKollect Smart Property',
    'cmp.smart_sub': 'Automated & Efficient',
    'cmp.recommended': 'RECOMMENDED',
    'cmp.cta': 'Upgrade to Smart Property',
    'cmp.trad': [
      'Manual rent collection',
      'Excel sheets for tracking',
      'Paper-based agreements',
      'No real-time updates',
      'Manual attendance tracking',
      'Phone calls for reminders',
      'No online payment',
      'Physical complaint register'
    ],
    'cmp.smart': [
      'Automatic rent collection',
      'Digital dashboard & reports',
      'Digital KYC & agreements',
      'Real-time occupancy updates',
      'Smart attendance system',
      'WhatsApp auto-reminders',
      'Multiple payment options',
      'In-app complaint management'
    ],

    // Upgrade Modal
    'um.badge': 'Upgrade to Smart Property',
    'um.h2': 'Leave the 1990s behind.',
    'um.sub': "Tell us about your property and we'll set up your dashboard in under 24 hours.",
    'um.name': 'Your name',
    'um.name_ph': 'Amit Sharma',
    'um.mobile': 'Mobile number',
    'um.mobile_ph': '+91 98xxxxxxxx',
    'um.city': 'City',
    'um.city_ph': 'Gurgaon',
    'um.beds': 'Beds / rooms',
    'um.beds_ph': 'e.g. 40',
    'um.proptype': 'Property type',
    'um.submit': 'Request my upgrade',
    'um.submitting': 'Submitting...',
    'um.consent': 'By submitting, you agree to be contacted by the RentKollect team. No spam, ever.',
    'um.invalid_mobile': 'Please enter a valid mobile number',
    'um.success_h': 'Request received!',
    'um.success_p_a': 'Our team will reach out to',
    'um.success_p_b': 'within 24 hours to walk you through the upgrade.',
    'um.done': 'Done',

    // Footer
    'ft.blurb': 'The easiest way to rent and manage your PGs and hostels.',
    'ft.quick_links': 'RentKollect',
    'ft.link_privacy': 'Privacy policy',
    'ft.link_terms': 'Terms & Conditions',
    'ft.link_data_deletion': 'Data deletion',
    'ft.link_contact': 'Contact us',
    'ft.contact': 'Contact us',
    'ft.address': 'H.No 59, Neelkanth Enclave, near Ekta Hospital, Badshahpur, Gurgaon, Haryana 122101, India',
    'ft.app_title': 'Get the app',
    'ft.app_waitlist': 'Native mobile apps are in final build — join the waitlist by requesting a demo above.',
    'ft.soon': 'COMING SOON',
    'ft.play_top': 'GET IT ON',
    'ft.play_bottom': 'Google Play',
    'ft.app_top': 'Download on the',
    'ft.app_bottom': 'App Store',
    'ft.head_office': 'Registered Office',
    'ft.hq_line1': 'H.No 59, Neelkanth Enclave, near Ekta Hospital,',
    'ft.hq_line2': 'Badshahpur, Gurgaon, Haryana 122101, India',
    'ft.legal_entity': 'RentKollect is a brand of Ramde Business Solutions LLP · GST 06ABMFR3856J1ZO · LLPIN ACR-9891',
    'ft.rights': (yr) => `© ${yr} Ramde Business Solutions LLP. All rights reserved · RentKollect™ is a registered brand.`
  },

  hi: {
    // Navbar
    'nav.for_managers': 'मैनेजर्स के लिए',
    'nav.login': 'लॉगिन',
    'nav.signup': 'साइन अप',
    'nav.tagline': 'मालिकों के लिए, एक मालिक द्वारा',
    'nav.lang_toggle': 'EN',
    'nav.lang_label': 'भाषा',

    // Beta banner
    'beta.pill': 'बीटा',
    'beta.message': 'हम beta में हैं — रॉकेट स्पीड से features ship कर रहे हैं। फ़ीडबैक है? DM करें।',
    'beta.message_short': 'Beta · रॉकेट स्पीड से shipping',

    // Hero
    'hero.brand': 'RentKollect',
    'hero.badge': '🏠 मालिकों के लिए, एक मालिक द्वारा',
    'hero.h1_line1': 'किराया पीछे भागना बंद करें।',
    'hero.h1_line2': 'अब मत जियें',
    'hero.h1_trail': ' में।',
    'hero.rotating_words': ['Excel', 'रजिस्टर', 'पुराने ऐप्स'],
    'hero.subtext':
      'RentKollect आपके PG, hostel या co-living को उसी तरह चलाता है जैसे पहले दिन से चलना चाहिए था — भारत में, एक मालिक द्वारा बनाया गया जिसने वो हर परेशानी ख़ुद झेली है जो अभी आप झेल रहे हैं।',
    'hero.tagline': 'समय बचाएँ। कम काम करें। ज़्यादा कमाएँ।',
    'hero.i_manage': 'मैं मैनेज करता हूँ',
    'hero.mobile_placeholder': 'मोबाइल नंबर डालें',
    'hero.submit_idle': 'डेमो के लिए रिक्वेस्ट करें',
    'hero.submit_loading': 'सबमिट हो रहा है...',
    'hero.toast_title': 'डेमो रिक्वेस्ट मिल गई!',
    'hero.toast_desc': (num) => `हम आपसे जल्द ही ${num} पर संपर्क करेंगे`,

    // Hero preview card
    'card.url': 'rentkollect.com/manager',
    'card.kicker': 'आपका super-app',
    'card.kicker_h': 'प्रॉपर्टी रेंटिंग, सॉल्व्ड।',
    'card.live': 'लाइव',
    'card.stat.collected': 'कलेक्ट',
    'card.stat.due': 'बकाया',
    'card.stat.occupancy': 'ऑक्युपेंसी',
    'card.f1.title': 'ऑटोमैटिक किराया और बकाया ट्रैकिंग',
    'card.f1.sub': 'देखें किसने paid किया, किसका pending है, किसको नज है',
    'card.f2.title': 'बल्क रूम और फ्लोर मैनेजमेंट',
    'card.f2.sub': '40 rooms सिर्फ़ 60 सेकंड में — tap करें, type नहीं',
    'card.f3.title': 'AI Command Center',
    'card.f3.sub': '"HSR Layout में ₹10k से ऊपर का dues दिखाओ"',
    'card.bharat_kicker': 'मेड इन भारत',
    'card.bharat_title_prefix': 'भारत का पहला AI-powered',
    'card.bharat_title_suffix': 'app',
    'card.property_words': ['PG', 'co-living', 'hostel'],
    'card.secure': '100% सुरक्षित',

    // Property types
    'prop.coliving': 'Co-Living',
    'prop.hostel': 'Hostel/PG',
    'prop.flat': 'Flat',
    'prop.studio': 'Studio',

    // Features
    'feat.live_badge': 'लाइव',
    'feat.ai_badge': 'AI · लाइव',
    'feat.soon_badge': 'जल्द आ रहा',
    'feat.new_badge': 'नया',
    'feat.stats_chip': (live, soon) => `${live} फ़ीचर्स लाइव · ${soon} जल्द आ रहे हैं`,
    'feat.recently_shipped_title': 'इस महीने लॉन्च हुए',
    'feat.recently_shipped_subtitle': "हर हफ़्ते नए फ़ीचर्स आते हैं। ये अभी-अभी आए:",
    'feat.recent.1_title': 'लाइव लाभ-हानि डैशबोर्ड',
    'feat.recent.1_desc': '6 महीने का रुझान, पिछली अवधि से तुलना, श्रेणी-वार खर्च।',
    'feat.recent.2_title': 'रियल-टाइम डेटा सिंक',
    'feat.recent.2_desc': 'फ़ोन पर किराया रिकॉर्ड करें — लैपटॉप 250ms में अपडेट।',
    'feat.recent.3_title': 'बैंक और UPI रूटिंग',
    'feat.recent.3_desc': 'हर प्रॉपर्टी के लिए अलग बैंक/UPI खाता।',
    'feat.recent.4_title': 'स्मार्ट किरायेदार जीवनचक्र',
    'feat.recent.4_desc': 'बुकिंग टोकन ऑटो-एडजस्ट। ज़रूरत हो तो नोटिस रद्द भी हो।',
    'feat.h2_a': 'आपके',
    'feat.h2_b': 'PG, hostel,',
    'feat.h2_c': 'या',
    'feat.h2_d': 'co-living',
    'feat.h2_trail': ' को चलाने के लिए सब कुछ।',
    'feat.intro':
      'भारतीय प्रॉपर्टी मालिकों के लिए ज़ीरो से बनाया गया — कोई जुगाड़ नहीं, कोई Excel की भागदौड़ नहीं, रात 11 बजे tenants के पीछे भागना नहीं। नीचे हर फ़ीचर उन मालिकों की बातचीत से आया है जो Rajender Nagar में 20-बेड का PG और HSR Layout में 200-बेड co-living चला रहे हैं।',
    'feat.footer_note_a': 'हम तेज़ shipping करते हैं। जो फ़ीचर्स',
    'feat.footer_note_b': 'कहे हैं, वो अभी development में हैं — ऊपर form में अपना नंबर डालें, live होते ही हम ping कर देंगे।',

    'feat.money.title': 'पैसे और किराया कलेक्शन',
    'feat.money.tag': '"भाई पैसा कब आएगा?" — solved।',
    'feat.money.f1': 'ऑटोमैटिक किराया और बकाया ट्रैकिंग',
    'feat.money.f2': 'Ageing Report के साथ बकाया डैशबोर्ड',
    'feat.money.f3': 'फ़ोटो OCR के साथ खर्च ट्रैकिंग',
    'feat.money.f4': 'हर प्रॉपर्टी की 6-महीने की Revenue Trend',
    'feat.money.f5': 'ऑटो Invoices और रसीद (PDF)',
    'feat.money.f6': 'WhatsApp पेमेंट रिमाइंडर और रसीद',
    'feat.money.f7': 'Prepaid क्रेडिट Wallet',
    'feat.money.f8': 'लाइव लाभ-हानि डैशबोर्ड — 6 महीने का रुझान',
    'feat.money.f9': 'बैंक और UPI रूटिंग — हर प्रॉपर्टी का अलग खाता',
    'feat.money.f10': 'रियल-टाइम सिंक — हर डिवाइस पर तुरंत अपडेट',

    'feat.prop.title': 'प्रॉपर्टी और कमरे',
    'feat.prop.tag': 'आपका गुड़गाँव का PG और HSR Layout का co-living, एक ही डैशबोर्ड पर।',
    'feat.prop.f1': 'मल्टी-प्रॉपर्टी मैनेजमेंट',
    'feat.prop.f2': 'बल्क रूम Add (tap करें, type नहीं)',
    'feat.prop.f3': 'रूम फ़ोटो और फ्लोर लेआउट',
    'feat.prop.f4': 'हर प्रॉपर्टी के लिए पब्लिक लिस्टिंग वेबसाइट',
    'feat.prop.f5': 'बिजली मीटर ट्रैकिंग',

    'feat.ten.title': 'Tenants और Leads',
    'feat.ten.tag': 'चाय-पानी पूछताछ से साइन हुए agreement तक — एक ही flow में।',
    'feat.ten.f1': 'Tenant Profiles, KYC और डॉक्युमेंट्स',
    'feat.ten.f2': 'AI Lead Scoring के साथ Lead Management',
    'feat.ten.f3': 'Bookings और Move-in Flow',
    'feat.ten.f4': 'डिजिटल Rent Agreement',
    'feat.ten.f5': 'Police Verification Register',
    'feat.ten.f6': 'आधार Verification',
    'feat.ten.f7': 'बुकिंग → मूव-इन → किरायेदार, टोकन ऑटो-एडजस्ट',
    'feat.ten.f8': 'नोटिस अवधि प्रबंधन (नोटिस दें, रद्द करें, चेक-आउट करें)',

    'feat.ops.title': 'रोज़मर्रा का काम',
    'feat.ops.tag': 'मेस, maintenance, सफ़ाई — अब WhatsApp ग्रुप्स की गड़बड़ नहीं।',
    'feat.ops.f1': 'Complaints और Ticketing',
    'feat.ops.f2': 'Tasks और Staff को काम देना',
    'feat.ops.f3': 'Food / Mess मेनू प्लानिंग',
    'feat.ops.f4': 'रोज़ की सफ़ाई Checklist',
    'feat.ops.f5': 'Assets रजिस्टर (गीज़र, AC, beds)',
    'feat.ops.f6': 'Role-based Access के साथ Team Management',
    'feat.ops.f7': 'Notice Board (tenants और staff को broadcast)',
    'feat.ops.f8': 'Visitor Log (front-desk register)',

    'feat.intel.title': 'Intelligence और Automation',
    'feat.intel.tag': 'App सोचे, आप जिएँ।',
    'feat.intel.f1': 'AI Command Center (अपने PG के बारे में कुछ भी पूछें)',
    'feat.intel.f2': 'Custom Reports (dues, collections, P&L)',
    'feat.intel.f3': 'Smart Reminders और Scheduler',
    'feat.intel.f4': 'WhatsApp Business Automation',
    'feat.intel.f5': 'Native Android और iOS App',

    // Comparison
    'cmp.h2': '2026 में आकर भी 1990 वाला रेंट क्यों?',
    'cmp.sub': 'समय बचाएँ, कम काम करें, ज़्यादा कमाएँ',
    'cmp.trad_title': 'पुरानी तरह की प्रॉपर्टी',
    'cmp.trad_sub': 'मैनुअल और वक़्त खाने वाला',
    'cmp.smart_title': 'RentKollect Smart Property',
    'cmp.smart_sub': 'ऑटोमेटेड और असरदार',
    'cmp.recommended': 'रेकमेंडेड',
    'cmp.cta': 'Smart Property पर Upgrade करें',
    'cmp.trad': [
      'मैनुअल किराया कलेक्शन',
      'ट्रैकिंग के लिए Excel शीट्स',
      'काग़ज़ वाले agreements',
      'Real-time अपडेट नहीं',
      'मैनुअल attendance ट्रैकिंग',
      'रिमाइंडर के लिए फ़ोन कॉल',
      'Online payment नहीं',
      'Physical complaint रजिस्टर'
    ],
    'cmp.smart': [
      'ऑटोमैटिक किराया कलेक्शन',
      'डिजिटल डैशबोर्ड और रिपोर्ट्स',
      'डिजिटल KYC और agreements',
      'Real-time ऑक्युपेंसी अपडेट',
      'Smart attendance सिस्टम',
      'WhatsApp auto-रिमाइंडर',
      'कई payment ऑप्शन',
      'In-app complaint मैनेजमेंट'
    ],

    // Upgrade Modal
    'um.badge': 'Smart Property पर Upgrade करें',
    'um.h2': '1990 को पीछे छोड़ दें।',
    'um.sub': 'अपनी प्रॉपर्टी के बारे में बताएँ, हम 24 घंटे से कम में आपका डैशबोर्ड सेटअप कर देंगे।',
    'um.name': 'आपका नाम',
    'um.name_ph': 'अमित शर्मा',
    'um.mobile': 'मोबाइल नंबर',
    'um.mobile_ph': '+91 98xxxxxxxx',
    'um.city': 'शहर',
    'um.city_ph': 'गुड़गाँव',
    'um.beds': 'Beds / rooms',
    'um.beds_ph': 'जैसे 40',
    'um.proptype': 'प्रॉपर्टी का प्रकार',
    'um.submit': 'मेरा Upgrade रिक्वेस्ट करें',
    'um.submitting': 'सबमिट हो रहा है...',
    'um.consent': 'सबमिट करने पर आप RentKollect टीम से संपर्क के लिए सहमत हैं। कभी स्पैम नहीं।',
    'um.invalid_mobile': 'सही मोबाइल नंबर डालें',
    'um.success_h': 'रिक्वेस्ट मिल गई!',
    'um.success_p_a': 'हमारी टीम',
    'um.success_p_b': 'पर 24 घंटे में आपसे संपर्क करेगी।',
    'um.done': 'हो गया',

    // Footer
    'ft.blurb': 'आपके PGs और hostels को रेंट करने और मैनेज करने का सबसे आसान तरीक़ा।',
    'ft.quick_links': 'RentKollect',
    'ft.link_privacy': 'Privacy policy',
    'ft.link_terms': 'Terms & Conditions',
    'ft.link_data_deletion': 'डेटा हटाएँ',
    'ft.link_contact': 'संपर्क करें',
    'ft.contact': 'संपर्क करें',
    'ft.address': 'H.No 59, Neelkanth Enclave, Ekta Hospital के पास, Badshahpur, Gurgaon, Haryana 122101, India',
    'ft.app_title': 'ऐप पाएँ',
    'ft.app_waitlist': 'Native mobile apps अंतिम build में हैं — ऊपर डेमो request करके waitlist join करें।',
    'ft.soon': 'जल्द आ रहा',
    'ft.play_top': 'GET IT ON',
    'ft.play_bottom': 'Google Play',
    'ft.app_top': 'Download on the',
    'ft.app_bottom': 'App Store',
    'ft.head_office': 'Registered Office',
    'ft.hq_line1': 'H.No 59, Neelkanth Enclave, Ekta Hospital के पास,',
    'ft.hq_line2': 'Badshahpur, Gurgaon, Haryana 122101, India',
    'ft.legal_entity': 'RentKollect is a brand of Ramde Business Solutions LLP · GST 06ABMFR3856J1ZO · LLPIN ACR-9891',
    'ft.rights': (yr) => `© ${yr} Ramde Business Solutions LLP. सर्वाधिकार सुरक्षित · RentKollect™ एक registered brand है।`
  }
};

export default translations;
